import { useContext, useEffect, useRef, useState } from 'react';
import { OrgAuthContext } from '../../../context/OrgAuthContext';
import { Link, useLocation } from 'react-router-dom';
import { CampLeftMenuData } from '../../orgLeftMenu/leftMenuData';
import Logout from '../../../assets/icons/trvto_logout.svg';
import CollapseMenuIcon from '../../../assets/icons/trvto_sidebarMenu.svg';
import ArrowBack from '../../../assets/icons/trvto_closeWhite.svg';

const OrgCampLeftMenu = ({ showSidebar }) => {
    const { orgLogoutFun } = useContext(OrgAuthContext);
    const [expandSidebar, setExpandSidebar] = useState(false);
    const sidebarRef = useRef(null);
    const location = useLocation();
    const currentPath = location.pathname.split('/')[3];

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                setExpandSidebar(false);
            }
        };

        // Attach event listener
        document.addEventListener('mousedown', handleClickOutside);

        // Clean up event listener on component unmount
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    return (
        <>
            <button
                type='button'
                onClick={() => setExpandSidebar(!expandSidebar)}
                className={`menuExpand ${expandSidebar ? 'menuExpandActive' : ''}`}
            >
                <img src={!expandSidebar ? CollapseMenuIcon : ArrowBack} alt='trvto_Close' width={24} height={24} />
            </button>
            <nav className={`nav-menu ${expandSidebar || showSidebar ? 'active' : ''}`} ref={sidebarRef}>
                <ul className='nav-menu-items'>
                    <div>
                        <li className={'nav-text show-menu'}>
                            <Link to='#' onClick={() => setExpandSidebar(!expandSidebar)}>
                                <img
                                    src={!expandSidebar ? CollapseMenuIcon : ArrowBack}
                                    alt='trvto_Close'
                                    width={30}
                                    height={30}
                                />
                            </Link>
                        </li>
                        {CampLeftMenuData.map((item, index) => {
                            const isActive = item.path.includes(currentPath);
                            return (
                                <li key={index} className={`nav-text ${isActive ? 'active' : ''}`}>
                                    <Link
                                        to={item.path}
                                        onClick={() => {
                                            setExpandSidebar(false);
                                        }}
                                    >
                                        <img src={isActive ? item.activeIcon : item.icon} alt={item.title} />
                                        <span className={!expandSidebar && !showSidebar ? 'nav-title' : 'show'}>
                                            {item.title}
                                        </span>
                                    </Link>
                                </li>
                            );
                        })}
                    </div>
                    <div>
                        <li className='nav-text'>
                            <Link onClick={() => orgLogoutFun()}>
                                <img src={Logout} alt='trvto_logout' />
                                <span className={!expandSidebar && !showSidebar ? 'nav-title' : 'show'}>Logout</span>
                            </Link>
                        </li>
                    </div>
                </ul>
            </nav>
        </>
    );
};

export default OrgCampLeftMenu;
